module.exports = __webpack_public_path__ + "static/media/paiming3.4faf49e9.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_130/image/paiming3.png
// module id = 382
// module chunks = 0